const TRUST_ITEMS = [
  { index: "01", label: "AI-agent mint", detail: "Public Skill handoff gates every Ape" },
  { index: "02", label: "Codex first", detail: "Recommended client, not a required vendor" },
  { index: "03", label: "Hook to holders", detail: "Official pool fees route to active NFTs" },
  { index: "04", label: "Community LP", detail: "90-day UNCX lock, then NFT-gated claims" },
  { index: "00", label: "No launch admin", detail: "No pause, upgrade, or admin mint path" }
] as const;

export default function TrustBar() {
  return (
    <div className="trust-bar" aria-label="CODE APE trust summary">
      {TRUST_ITEMS.map((item) => (
        <div key={item.label} className="trust-bar__item">
          <span className="trust-bar__index">{item.index}</span>
          <strong>{item.label}</strong>
          <span>{item.detail}</span>
        </div>
      ))}
    </div>
  );
}
